import Vue from "vue";
import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
      loadingContracts: false,
      contracts: [],
      isContractsSearchList: false,
      contractsSearchList: [],
      loadingSingleContract: false,
      singleContract: {},
      // Additional docs
      loadingSingleAdditional: false,
      additionalDetails: null,
      // The acts of the contract open in DetaliiContractProductie, oldest first
      additionalsList: [],
    }),
    mutations: {
      setLoadingContracts(state, isLoading) {
        state.loadingContracts = isLoading;
      },
      loadContractsManufacturing(state, items) {
        items.forEach(item => {
          if (item.detalii) {
            item.detalii = JSON.parse(item.detalii);
          }
        })
        state.contracts = items;
      },
      setContractsSearch(state, isSearch) {
        state.isContractsSearchList = isSearch;
      },
      setLoadingSingleContract(state, isLoading) {
        state.loadingSingleContract = isLoading;
      },
      loadSingleContractManufacturing(state, item) {
        if (item.detalii) {
          item.detalii = JSON.parse(item.detalii);
        }
        if (item.gard_obj) {
          item.gard_obj = JSON.parse(item.gard_obj);
        }
        if (item.alte_obj) {
          item.alte_obj = JSON.parse(item.alte_obj);
        }
        if (item.text_content) {
          item.text_content = JSON.parse(item.text_content);
        }
        if (item.aditional_content) {
          item.aditional_content = JSON.parse(item.aditional_content);
        }
        state.singleContract = item;
      },
      setSingleContractContent(state, payload) {
        if (state.singleContract.id_contract == payload.id) state.singleContract.text_content = payload.content;
      },
      setContractStatusReview(state, payload) {
        const idx = state.contracts.findIndex((contract) => {
          return contract.id_contract === payload.id;
        });
        if (idx !== -1) {
          state.contracts[idx].status_review = payload.status_review;
          state.contracts[idx].status_review_obs = payload.status_review_obs;
        }
      },
      setContractStatus(state, payload) {
        const idx = state.contracts.findIndex((c) => c.id_contract === payload.id);
        if (idx !== -1) state.contracts[idx].status_contract = payload.status_contract;
      },
      // ************
      // Additional docs
      setLoadingSingleAdditional(state, isLoading) {
        state.loadingSingleAdditional = isLoading;
      },
      loadAdditionalDetails(state, item) {
        if (item.gard_obj) {
          item.gard_obj = JSON.parse(item.gard_obj);
        }
        if (item.alte_obj) {
          item.alte_obj = JSON.parse(item.alte_obj);
        }
        if (item.aditional_content) {
          item.aditional_content = JSON.parse(item.aditional_content);
        }
        state.additionalDetails = item;
      },
      loadAdditionalsList(state, items) {
        state.additionalsList = items;
      },
      setSingleAdditionalContent(state, payload) {
        if (state.additionalDetails.id_aditional == payload.id_aditional) state.additionalDetails.aditional_content = payload.content;
      },
    },
    actions: {
      async fetchContractsManufacturing({ commit, rootGetters }, payload) {
        commit("setLoadingContracts", true);

        const user = rootGetters.loggedUser;
        const urlParams = {
          fromDate: payload.date1,
          toDate: payload.date2,
        };
        
        let url = process.env.VUE_APP_HUB_API_HOST + `api/manufacturing/contracts/${payload.country}/month`;
        if (!["admin", "superuser", "user"].includes(user.rol)) {
          url += `/${user.id_user}`;
        }
    
        await Vue.http
          .get(url, {
            headers: headers,
            params: urlParams
          })
          .then(function (response) {
            commit("loadContractsManufacturing", response.body);
            commit("setContractsSearch", false);
            commit("setLoadingContracts", false);
          })
          .catch(function (error) {
            console.log("Error: " + error);
            commit("setLoadingContracts", false);
          });
      },
      async fetchContractsManufacturingBySearchTerm({ commit, rootGetters }, payload) {
        commit("setLoadingContracts", true);

        const user = rootGetters.loggedUser;
        const urlParams = {
          searchTerm: payload.searchTerm,
        };

        let url = process.env.VUE_APP_HUB_API_HOST + `api/manufacturing/contracts/${payload.country}/search`;

        if (!["admin", "superuser", "user"].includes(user.rol)) {
          url += `/${user.id_user}`;
        }

        await Vue.http
          .get(url, {
            headers: headers,
            params: urlParams
          })
          .then(function (response) {
            commit("loadContractsManufacturing", response.body);
            commit("setContractsSearch", true);
            commit("setLoadingContracts", false);
          })
          .catch(function (error) {
            console.error("Error: " + error);
            commit("setLoadingContracts", false);
          });
      },
      async fetchSingleContractManufacturing({ commit }, contractId) {
        commit("setLoadingSingleContract", true);

        const url = process.env.VUE_APP_HUB_API_HOST + `api/productie/contract/${contractId}`;

        await Vue.http
          .get(url, {
            headers: headers,
          })
          .then(function (response) {
            commit("loadSingleContractManufacturing", response.body);
            commit("setLoadingSingleContract", false);
          })
          .catch(function (error) {
            console.error("Error: " + error.status + " " + error.statusText);
            commit("setLoadingSingleContract", false);
          });
      },
      updateContractStatus({ commit }, payload) {
        Vue.http
          .put(process.env.VUE_APP_HUB_API_HOST + "api/manufacturing/contracts/status", payload, { headers })
          .then(function (response) {
            M.toast({ html: response.body.message, classes: "bg-green-500" });
            commit("setContractStatus", payload);
          })
          .catch(function (error) {
            console.error("Error: " + error.status + " " + error.statusText);
          });
      },
      updateContractReviewStatus({ commit }, payload) {
        const url = process.env.VUE_APP_HUB_API_HOST + "api/productie/contract/status-review";

        Vue.http
          .put(url, payload, {
              headers: headers,
          })
          .then(function (response) {
            router.push({
              query: M.toast({
                html: response.body,
                classes: "bg-green-500",
              }),
            })
            commit("setContractStatusReview", payload);
          })
          .catch(function (error) {
            console.log("Error: " + error.status + " " + error.statusText);
          })
      },
      updateContractContent({ commit }, payload) {
        const url = process.env.VUE_APP_HUB_API_HOST + "api/productie/contract/editcontent";

        Vue.http
          .put(url, payload, {
            headers: headers,
          })
          .then(function (response) {
            M.toast({
              html: response.body,
              classes: "bg-green-500",
            });
            commit("setSingleContractContent", payload);
          })
          .catch(function (error) {
            console.log("Error: " + error.status + " " + error.statusText);
          });
      },
      deleteContract(context, payload) {
        const url = process.env.VUE_APP_HUB_API_HOST + `api/productie/contract/delete/${payload.id}`;

        Vue.http
          .delete(url, {
            headers: headers,
            params: { user_id: payload.user_id },
          })
          .then(function (response) {
            M.toast({
              html: response.body,
              classes: "bg-green-500",
            });
            router.push({ name: "ContracteProductie" });
          })
          .catch(function (error) {
            console.log("Error: " + error.status + " " + error.statusText);
            M.toast({
              html: (error.body && error.body.error) || 'Eroare la stergere contract!',
              classes: "bg-red-500",
            });
          });
      },
      // ************
      // Additional docs
      async fetchContractAdditionals({ commit }, contractId) {
        commit("loadAdditionalsList", []);

        const url = process.env.VUE_APP_HUB_API_HOST + `api/productie/contracte/aditionale/list/${contractId}`;

        await Vue.http
          .get(url, {
            headers: headers,
          })
          .then(function (response) {
            commit("loadAdditionalsList", response.body);
          })
          .catch(function (error) {
            console.error("Error: " + error.status + " " + error.statusText);
          });
      },
      async fetchSingleAdditionalDetails({ commit }, additionalId) {
        commit("setLoadingSingleAdditional", true);
        commit("loadAdditionalDetails", {});

        const url = process.env.VUE_APP_HUB_API_HOST + `api/productie/contracte/aditionale/act/${additionalId}`;

        await Vue.http
          .get(url, {
            headers: headers,
          })
          .then(function (response) {
            commit("loadAdditionalDetails", response.body);
            commit("setLoadingSingleAdditional", false);
          })
          .catch(function (error) {
            console.error("Error: " + error.status + " " + error.statusText);
            commit("setLoadingSingleAdditional", false);
          });
      },
      async addAdditional({ commit }, payload) {
          commit("setLoadingSingleAdditional", true);

          const url = process.env.VUE_APP_HUB_API_HOST + `api/productie/contracte/aditionale/add`;

          await Vue.http
            .post(url, payload,
              {
                headers: headers,
              }
            )
            .then(function (response) {
              M.toast({
                html: response.body.message,
                classes: "green",
              });
              router.push({
                name: "AditionalContractProductie",
                params: {
                  id: payload.contract_id,
                  idAditional: response.body.id_aditional,
                },
              });
              commit("setLoadingSingleAdditional", false);
            })
            .catch(function (error) {
              console.error(error);
              // a broken rule (offer missing, another client's, already current) comes back as a 400
              M.toast({
                html: (error.body && error.body.error) || "Eroare la generare!",
                classes: "red",
              });
              commit("setLoadingSingleAdditional", false);
            });
      },
      updateAdditionalContent({ commit }, payload) {
        const url = process.env.VUE_APP_HUB_API_HOST + "api/productie/contracte/aditionale/editcontent";

        Vue.http
          .put(url, payload, {
            headers: headers,
          })
          .then(function (response) {
            M.toast({
              html: response.body,
              classes: "bg-green-500",
            });
            commit("setSingleAdditionalContent", payload);
          })
          .catch(function (error) {
            console.log("Error: " + error.status + " " + error.statusText);
          });
      },
      deleteAdditionalManufacturing(context, payload) {
        const url = process.env.VUE_APP_HUB_API_HOST + `api/productie/contracte/aditionale/delete/${payload.id_aditional}`;

        Vue.http
          .delete(url, {
            headers: headers,
            // the API lets only admins and superusers delete
            params: { user_id: payload.user_id },
          })
          .then(function (response) {
            M.toast({
              html: response.body.message,
              classes: "bg-gray-500",
            });
            router.push({ 
              name: "DetaliiContractProductie",
              params: {
                id: payload.id_contract,
              },
            });
          })
          .catch(function (error) {
            console.log("Error: " + error.status + " " + error.statusText);
            M.toast({
              html: (error.body && error.body.error) || "Eroare la stergere act aditional!",
              classes: "bg-red-500",
            });
          });
        
      },
    }    
}